module.exports = __webpack_public_path__ + "img/takeAndGoGreen.3ff6366e.svg";